module.exports = __webpack_public_path__ + "img/2.214fd563.jpg";